var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,19.5c2.1,0,3.79,1.7,3.79,3.79v22.91h22.91c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.79-3.8,3.79h-22.91v22.91c0,2.1-1.7,3.8-3.79,3.8s-3.8-1.7-3.8-3.8v-22.91h-22.91c-2.1,0-3.79-1.7-3.79-3.79s1.7-3.8,3.79-3.8h22.91v-22.91c0-2.1,1.7-3.79,3.8-3.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeAdd);
export default __webpack_public_path__ + "static/media/acae_add.3ebbd048.svg";
export { ForwardRef as ReactComponent };